let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1xmbR")).then(() => parcelRequire('9Kb0h'));